import { AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { first, map, Observable } from 'rxjs';
import { UserEmailSearchModel } from '..';

export function duplicateEmailValidator(emailSearchResult$: Observable<UserEmailSearchModel>): AsyncValidatorFn {
  return function duplicateValidatorFn(): Observable<ValidationErrors | null> {
    return emailSearchResult$.pipe(
      first(),
      map((emailSearch: UserEmailSearchModel) => {
        if (emailSearch?.exist) {
          return { duplicateEmail: true };
        } else {
          return null;
        }
      }),
    );
  };
}
